import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { RefreshState } from '../refresh/refresh-actions';
import { SetJobLevels } from './job-level-action';

export const JOB_LEVEL_TOKEN = new StateToken<any[]>('JobLevel');

@State({
    name: JOB_LEVEL_TOKEN,
    defaults: []
})
@Injectable()
export class JobLevelState {
    @Action(RefreshState)
    refresh(ctx: StateContext<any>, action: RefreshState) {
        if (action.data.name === JOB_LEVEL_TOKEN.getName()) {
            ctx.setState(action.data.state);
        }
    }

    @Action(SetJobLevels)
    set(ctx: StateContext<any>, action: SetJobLevels) {
        ctx.setState(action.data);
    }
}
